(function () {
    'use strict';

    angular
        .module('app.paymentTemplates')
        .controller('PaymentTemplateReceiptController', PaymentTemplateReceiptController);

    PaymentTemplateReceiptController.$inject = ['$stateParams', '$sce', 'common', 'dataservice', '$rootScope'];
    /* @ngInject */
    function PaymentTemplateReceiptController($stateParams, $sce, common, dataservice, $rootScope) {
        var vm = this;
        vm.title = 'Payment Receipt';
        vm.item = {};
        vm.isLicenseValid = true;
        vm.ReservationOrInvoiceLabel = "Invoice No";
        vm.cancelled = false;
        vm.loaded = false;
        activate();

        function activate() {
            var promises = [getItem()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
                common.notifier.notify(common.config.events.stateChanged);
            }, function (error) { });
        }

     
        function getItem() {
            var val = $stateParams.id;

            return dataservice.getItem('api/PaymentTemplates/Receipt/' + val).then(function (response) {
                vm.item = response.data;
                vm.loaded = true;
                vm.cancelled = response.data.ResponseCode == 3;
                if (vm.item.ReceiptPageTitle) {
                    $rootScope.title = vm.item.ReceiptPageTitle;
                }
                if (vm.item.EmsTransactionType != -86) {
                    vm.ReservationOrInvoiceLabel = vm.item.ReservationIDLabel;
                }
            }, function (error) { });
        }

    }
})();
